module.exports = __webpack_public_path__ + "static/media/team_won.6f68e72e.mp3";